import React from "react";

export type Project = {
  id: string;
  title: string;
  primaryLink?: string;
  extraLinks?: { label: string; href: string }[];
  tags: string[]; // will drive the top labels later
  summary: string; // short middle-column blurb
  body: React.ReactNode; // full 3rd-column content (text + screenshots)
  screenshots?: string[];
};

export const PROJECTS: Project[] = [
    
//     {
//   id: "adsense-explorer",
//   title: "AdSense Explorer",
//   primaryLink: "https://learnforeverlearn.com/adsense/",
//   tags: ["Money", ],
//   screenshots: ["screenshots/adsense.jpg"],
//   summary:
//     "Experiment with revenue from web ads: explore RPM, views per day, and what it takes to earn specific yearly amounts.",
//   body: (
//     <>
//       <p>
//         This visualization lets you explore how much you might make from Google
//         AdSense depending on:
//       </p>
//       <ul>
//         <li>How many ad views you get per day.</li>
//         <li>Your RPM (revenue per thousand impressions).</li>
//         <li>A yearly income goal you choose interactively.</li>
//       </ul>

//       <p>
//         The tool shades the region of views/RPM combinations that meet (or fail
//         to meet) your chosen income target, making the economics immediately
//         visible.
//       </p>
//     </>
//   ),
// },

  {
    id: "bayesian-bandit-explorer",
    title: "Bayesian Bandit Explorer",
    primaryLink: "https://learnforeverlearn.com/bandits/",
    tags: ["Bandits", "Statistics", "Math",],
    screenshots: ["screenshots/bandits.png"],
    summary:
      "A visual playground for Thompson sampling-style multi-armed bandits.",
    body: (
      <>
        <p>
          Inspired by{" "}
          <a
            href="http://tdunning.blogspot.com/2013/04/learning-to-rank-in-very-bayesian-way.html"
            target="_blank"
            rel="noreferrer"
          >
            Ted Dunning&apos;s work
          </a>
          , this app visualizes how Bayesian multi-armed bandits work (e.g.,
          for online ad ranking).
        </p>
        <p>
          You can adjust underlying click probabilities on the fly and watch how
          the bandit algorithm responds in real time.
        </p>
        {/* <p>
          For a related deep dive, see John Myles White’s book on bandit
          algorithms for website optimization.
        </p> */}
      </>
    ),
  },

  {
    id: "cooccurrence-matrix",
    title:
      "Co-occurrence Matrix Explorer (Simple Recommender System Demonstration)",
    primaryLink: "https://learnforeverlearn.com/cooccurrence/",
    tags: ["Math", "Statistics"],
    screenshots: ["screenshots/cooccurrence.png"],
    summary:
      "Shows how a simple recommender system works by visualizing user–item, co-occurrence, and recommendation-weight matrices.",
    body: (
      <>
        {/* <p>
          This visualization illustrates how a simple recommender system can be
          built from user–item interactions.
        </p> */}
        <p>
          It exposes all the key matrices involved and uses mouseover
          highlighting to show how the pieces relate.
        </p>
        {/* <p>
          It does not cover more advanced ranking methods (like log-likelihood
          ratio), but instead focuses on a transparent pipeline from raw
          interactions to recommendation weights.
        </p> */}
      </>
    ),
  },

  {
    id: "dress-level",
    title: "Determine Your Blue/Black or White/Gold ‘Dress Level’",
    primaryLink: "https://learnforeverlearn.com/dresslevel/",
    tags: ["Perception"],
    screenshots: ["screenshots/dress.png"],
    summary:
      "A small tool to quantify your personal ‘dress level’ on the famous blue/black vs white/gold ambiguity.",
    body: (
      <>
        <p>
          In February 2015, the internet melted down over the ambiguous colors
          of “the dress”—some people see blue/black, others white/gold.
        </p>
        <p>
          This tool lets you determine your personal “dress level,” showing
          where your perception lies along that continuum. Your level can differ
          from other people’s, which is part of the fun.
        </p>
      </>
    ),
  },

  {
    id: "emojiviz",
    title: "emojiviz",
    //primaryLink: "http://learnforeverlearn.com/emojiviz/",
    extraLinks: [
{label: "Blog post",             
    href:"http://www.nowherenearithaca.com/2015/11/emojiviz-experiments-with-visualization.html"
}
    ],
    tags: ["Twitter"],
    screenshots: ["screenshots/emoji_with_update.gif"],
    summary:
      "Uses Matthew Rothenberg’s emojitracker API to show real-time emoji popularity on an Archimedean spiral, with click-through to associated tweets.",
    body: (
      <>
        <p>
          This visualization uses an API by Matthew Rothenberg from{" "}
          <a href="http://emojitracker.com/" target="_blank" rel="noreferrer">
            emojitracker
          </a>{" "}
          that provides real-time counts of emoji usage in tweets (the twitter api for this is no longer available).
        </p>
        <p>
          Emojis are displayed in an Archimedean spiral that updates as
          popularity changes (the top set is fairly stable). Clicking an emoji
          let you watch the real-time tweets that contain it.
        </p>
        {/* <p>
          Notes on how this was built are here:{" "}
          <a
            href="http://www.nowherenearithaca.com/2015/11/emojiviz-experiments-with-visualization.html"
            target="_blank"
            rel="noreferrer"
          >
            emojiviz: experiments with visualization of emoji usage
          </a>
          .
        </p> */}
      </>
    ),
  },

  {
    id: "us-judicial-system",
    title: "Exploration of the US Judicial System",
    primaryLink: "http://learnforeverlearn.com/uscourtviz/",
    tags: ["Courts"],
    screenshots: [
        "screenshots/uscourts.png"
],
    summary:
      "Maps 300+ US courts and their appeal relationships, with mouseover details and links to court sites.",
    body: (
      <>
        <p>
          This visualization includes data from more than 300 US courts (federal
          and state), showing how they are connected through appeals flows.
        </p>
        <p>
          Hovering over a court reveals detailed information and links to the
          court’s website.
        </p>
        <p>
          The visualization has been donated to and incorporated into the Free
          Law Project’s CourtListener site.
        </p>
      </>
    ),
  },

  {
  id: "birth-casino",
  title: "“Do You Feel Lucky?” Birth Casino Installation",
  primaryLink: "https://www.inbarhasson.com/background-check",
//   extraLinks: [
//     {
//       label: "World Births & Deaths Visualization",
//       href: "https://worldbirthsanddeaths.com/",
//     },
//   ],
  screenshots: ["screenshots/birthcasino.avif"],
  tags: ["Population",  "Perspective", "Simulation",],
  // adjust / remove this if you name the screenshot differently
  // screenshots: ["screenshots/birth-casino.jpg"],
  summary:
    "A gallery installation that combines my real-time births-and-deaths simulation with a slot-machine-style interface, inviting visitors to gamble with their own moment of birth.",
  body: (
    <>
      <p>
        This piece is part of artist Inbar Hasson&apos;s <i>Background Check</i> series,
        in an installation titled <i>Do You Feel Lucky?</i>. It embeds my{" "}
        <b>World Births and Deaths, Simulated in Real-Time</b> visualization
        inside a “birth casino” experience.
      </p>
      <p>
        Visitors interact with a slot-machine-style interface that spins through
        possible birth moments while the background simulation quietly ticks
        along with real-time global births and deaths. The combination is meant
        to make the randomness of one&apos;s own existence feel both playful
        and slightly unsettling.
      </p>
      <p>
        My role was to adapt and integrate the births-and-deaths engine and
        visual layer so it could live as a physical, gallery-ready piece rather
        than just a web visualization.
      </p>
    </>
  ),
},

  {
    id: "change-blindness",
    title: "Exploring Change Blindness",
    primaryLink: "http://learnforeverlearn.com/changeblindness/",
    tags: ["Perception"],
    screenshots: ["screenshots/changeblindness.png"],
    summary:
      "Lets you experience change blindness using side-by-side, flicker, and fade modes to compare images.",
    body: (
      <>
        <p>
          
          <a
            href="http://en.wikipedia.org/wiki/Change_blindness"
            target="_blank"
            rel="noreferrer"
          >
            Change blindness 
          </a>
          {" "}is a phenomenon where changes in a visual stimulus can go unnoticed.
        </p>
        <p>
          You can compare how you detect differences between two images when:
        </p>
        <ul>
          <li>They’re placed side-by-side.</li>
          <li>They flicker between each other.</li>
          <li>They fade into each other.</li>
        </ul>
      </>
    ),
  },

  {
    id: "exploring-family-trees",
    title: "Exploring Family Trees",
    primaryLink: "https://learnforeverlearn.com/ancestors/",
    screenshots: [
        "screenshots/familytree_1.png","screenshots/familytree_2.png",
"screenshots/familytree_3.png",    ],
    extraLinks: [
      {
        label: "Lifespans View",
        href: "https://learnforeverlearn.com/ancestors/?lifespan=true",
      },
      {
        label: "Blog Post",
        href: "http://familytreeviz.blogspot.com/2015/09/features-of-family-tree-visualization.html",
      },
    ],
    tags: ["Genealogy"],
    summary:
      "Loads a GEDCOM or sample trees (e.g., British monarchy) and places everyone on a birth-year timeline to reveal generational staggering and pedigree collapse.",
    body: (
      <>
        <p>
          This interactive visualization loads your own family tree from a
          GEDCOM file or one of several samples (including the British monarchy
          as a demonstration of pedigree collapse). People are placed along a
          timeline based on birth year so you can see the staggering of
          generations over time, as well as the impact of pedigree collapse
        </p>
        <p>
          You can display flags based on birthplace and highlight potential
          immigrants to the USA, which is often tedious to spot in even modest
          trees.
        </p>
        <p>
          A summary of many features is in this blog post:{" "}
          <a
            href="http://familytreeviz.blogspot.com/2015/09/features-of-family-tree-visualization.html"
            target="_blank"
            rel="noreferrer"
          >
            Features of Family Tree Visualization
          </a>
          .
        </p>
        <p>
          The visualization also includes variations such as flag-based layouts
          and highlighting of potential immigrants.
        </p>
      </>
    ),
  },

  {
    id: "preattentive-attributes",
    title: "Exploring Preattentive Attributes",
    primaryLink: "https://learnforeverlearn.com/preattentive/",
    tags: ["Perception"],
    screenshots: ["screenshots/preattentive.png",],
    summary:
      "A collection of 30+ micro-visualizations demonstrating preattentive attributes and how they ‘pop out’ visually.",
    body: (
      <>
        <p>
          When we view an image, some visual properties are detected
          effortlessly and almost instantly—they “pop out.” These are called{" "}
          <b>preattentive attributes</b>.
        </p>
        <p>
          This visualization is actually a collection of 30+ interactive charts
          that let you explore different preattentive attributes, making it
          easier to understand how to use them for effective visualization
          design.
        </p>
      </>
    ),
  },

  {
    id: "explore-svg-markers",
    title: "Exploring SVG Markers",
    primaryLink: "https://learnforeverlearn.com/explore_svg_marker/",
    tags: ["SVG"],
    screenshots: [
        "screenshots/svgmarkers.png",
    ],
    summary:
      "Interactive control panel for SVG marker attributes to demystify how they affect rendered arrows and endpoints.",
    body: (
      <>
        <p>
          SVG markers can be notoriously finicky. This tool was built out of
          frustration to understand how the many marker parameters actually
          affect the rendered result.
        </p>
        <p>
          Inspired partly by Bret Victor’s work, you can drag inside little
          textboxes to smoothly adjust parameters and immediately see their
          effect on the rendered markers.
        </p>
      </>
    ),
  },

  {
    id: "exploring-mean",
    title: "Exploring the Arithmetic Mean",
    primaryLink: "https://learnforeverlearn.com/exploremean/",
    tags: ["Statistics", "Education"],
    screenshots: ["screenshots/mean.png"],
    summary:
      "Simple but interactive tool to build intuition for the arithmetic mean by dragging bars and watching the formula update.",
    body: (
      <>
        <p>
          This is an interactive visualization intended to build intuition for
          the statistical mean. It’s a simple topic, but still worth exploring
          visually.
        </p>
        <p>
          You can drag bars around and watch both the underlying equation and
          the resulting mean update in real time.
        </p>
      </>
    ),
  },

  {
    id: "black-scholes",
    title: "Exploring the Black-Scholes Equation",
    primaryLink: "https://learnforeverlearn.com/blackscholes",
    extraLinks: [
      {
        label: "Options Tab",
        href: "https://learnforeverlearn.com/blackscholes/?tab=options",
      },
      {
        label: "Notes: Black-Scholes Visualization",
        href: "http://www.nowherenearithaca.com/2016/05/notes-on-interactive-visualization-for.html",
      },
      {
        label: "Notes: Fitting Option Strategies",
        href: "http://www.nowherenearithaca.com/2016/07/dataviz-exploring-and-fitting-option.html",
      },
      {
        label: "Notes: Black Swans",
        href: "http://www.nowherenearithaca.com/2016/07/floating-profitloss-curve-in-black-swan.html",
      },
    ],
    tags: ["Finance", "Math", "Simulation"],
    screenshots: ["screenshots/black_scholes.png", "screenshots/black_swans.png"],
    summary:
      "Interactive exploration of Black–Scholes Greeks and option strategies, including experimental strategy-fitting and ‘black swan’ scenarios.",
    body: (
      <>
        <p>
          This visualization focuses on the Black–Scholes option pricing
          framework and has two main parts:
        </p>
        <ul>
          <li>Exploring the “Greeks” interactively.</li>
          <li>
            Exploring and constructing option strategies, visualizing their
            profit–loss curves, and experimenting with fitting strategies to a
            target P/L curve.
          </li>
        </ul>
        <p>
          The project is documented across several blog posts covering the
          visualization, strategy fitting, and the addition of black-swan
          behavior.
        </p>
      </>
    ),
  },

  {
    id: "pagerank-explorer",
    title: "Exploring the Google PageRank Algorithm",
    primaryLink: "https://learnforeverlearn.com/pagerank/",
    tags: ["Algorithms", "Math", "Education"],
    screenshots: ["screenshots/pagerank.png"],
    summary:
      "Interactive toy web graph where you can edit links and watch PageRank iterations and matrices update.",
    body: (
      <>
        <p>
          This visualization lets you experiment with a small web graph to see
          how the original{" "}
          <a
            href="http://en.wikipedia.org/wiki/PageRank"
            target="_blank"
            rel="noreferrer"
          >
            PageRank
          </a>{" "}
          algorithm works.
        </p>
        <p>
          You can:
        </p>
        <ul>
          <li>Add, edit, and delete links.</li>
          <li>
            Explore the underlying matrices and how they relate to link
            structure.
          </li>
          <li>Watch intermediate steps as the algorithm converges.</li>
        </ul>
        <p>
            The Google Matrix is the core component of the PageRank algorithm.   
            It has a row and column for each web page indexed by Google.  
            Since there are more than 42 billion such pages, 
            if the Google matrix for the entire web were written out on a web page as is done here (with about a quarter inch per column),  
            your screen would need to be almost 166,000 miles wide and tall.  
            This would extend almost 70% of the way to the moon.  
            In practice, techniques are used in the calculations that exploit the fact that almost all of the entries of the matrix are 0.
        </p>
      </>
    ),
  },

  {
    id: "exploring-lognormal",
    title: "Exploring the Lognormal Distribution",
    primaryLink: "https://learnforeverlearn.com/explorelognormal/",
    screenshots: ["screenshots/lognormal.png"],
    extraLinks: [
      // {
      //   label: "Chrome App",
      //   href: "https://chrome.google.com/webstore/detail/exploring-the-lognormal-d/kfpmohkiaaienjkfobdolppopnabfnhi",
      // },
    ],
    tags: ["Statistics", "Education"],
    summary:
      "Shows how the lognormal distribution and its underlying normal relate, with draggable parameters and MathJax-rendered formulas.",
    body: (
      <>
        <p>
          The{" "}
          <a
            href="http://en.wikipedia.org/wiki/Log-normal_distribution"
            target="_blank"
            rel="noreferrer"
          >
            lognormal distribution
          </a>{" "}
          appears in many domains. This visualization lets you explore:
        </p>
        <ul>
          <li>How its parameters affect its shape.</li>
          <li>The relationship to the underlying normal distribution.</li>
        </ul>
        <p>
          You can drag bars or use text-box dragging to change parameters. The
          PDF equations for the lognormal and underlying normal are rendered
          with MathJax.
        </p>
      </>
    ),
  },

  {
  id: "knox-county-budget",
  title: "Exploring the Knox County Budget",
  primaryLink: "https://learnforeverlearn.com/kcb/",
  tags: ["Budget" , "Money",],
  summary:
    "Interactive viewer for the Knox County, Tennessee budget, showing how hundreds of millions of dollars flow from revenue sources to school and non-school spending.",
  screenshots: [
    "screenshots/kcb-budget.jpg", // update this filename if you saved it differently
  ],
  body: (
    <>
      <p>
        This visualization explores the Knox County (Tennessee) budget using a
        Sankey-style flow diagram paired with a stacked bar chart.
      </p>
      <p>
        You can see how total receipts break down into revenue sources (local
        taxes, state funding, etc.) and how that money flows into major spending
        buckets such as schools and non-school services.
      </p>
      <p>
        The bottom bar chart compares the overall budget structure across years,
        making it easier to spot shifts in spending and revenue mix over time.
      </p>
    </>
  ),
},

// maybe problem wth google api script?
//   {
//     id: "us-federal-budget",
//     title: "Exploring the US Federal Budget, 1962–2019",
//     primaryLink: "http://learnforeverlearn.com/usbudget/",
//     tags: ["Budget"],
//     summary:
//       "Interactive exploration of US federal receipts and spending from 1962–2019 with drill-down to line items and time series.",
//     body: (
//       <>
//         <p>
//           This visualization explores various aspects of the US Federal Budget
//           using Office of Management and Budget data for 1962–2019.
//         </p>
//         <p>
//           You can:
//         </p>
//         <ul>
//           <li>See the breakdown of receipts and spending.</li>
//           <li>Drill down into individual line items.</li>
//           <li>View time-series charts for specific categories.</li>
//         </ul>
//       </>
//     ),
//   },


{
  id: "headshot-analyzer",
  title: "Headshot Analyzer",
  primaryLink: "https://learnforeverlearn.com/headshotanalyzer/",
  tags: [ "Perception",],
  summary:
    "Prototype headshot analyzer using face-api.js to estimate age, emotion, and eye-region colors, plus palette comparisons with and without the face.",
  screenshots: ["screenshots/headshotanalyzer.jpg"],
  body: (
    <>
      <p>
        This work-in-progress tool uses <code>face-api.js</code> in the
        browser to analyze a single headshot. It estimates age and gender,
        shows basic emotion probabilities, and extracts color palettes from
        the face, eyes, and background.
      </p>
      <p>
        You can paste an image URL or upload an image file, then compare:
      </p>
      <ul>
        <li>Dominant colors in the full image vs. the face region only.</li>
        <li>Eye-region color palettes for each eye.</li>
        <li>
          A version of the image with the face masked out, to see how much
          the face dominates the overall palette.
        </li>
      </ul>
    </>
  ),
},

{
  id: "irony-categorization",
  title: "Categorization of Irony Examples",
  primaryLink: "https://learnforeverlearn.com/ironycat/",
  tags: ["Irony", "Psychology"],
  extraLinks: [
    {label: "Blog post",
    href: "https://thoughtsonirony.blogspot.com/2016/02/towards-subjective-numerical.html"
    }
  ],
  summary:
    "An evolving table that numerically scores different examples of irony across multiple dimensions such as humor, hypocrisy, reversal of expectations, and more.",
  screenshots: ["screenshots/irony.png"],
  body: (
    <>
      <p>
        This project is an ongoing attempt to quantify and categorize examples
        of <b>irony</b>. Each row represents an example (usually an image or a
        scenario) with numeric ratings across several dimensions, including
        twinge factor, humor, incongruity, hypocrisy, reversal of expectations,
        sadness, regret, and more.
      </p>
      <p>
        The table is sortable by any column, and mousing over an image enlarges
        it so you can see the context more clearly. Visitors can also submit
        their own rated examples to gradually expand the dataset.
      </p>
      <p>
        <q style={{fontStyle: "italic"}}>'irony is a “...semantically complex process of relating, differentiating, and combining said and unsaid meanings" ... this process of differentiation and relation involves a rapid oscillation between two different meanings.'</q>
<p style={{marginLeft: "20px"}}>
From the wikipedia article on Linda Hutcheon's "Irony's Edge: The Theory and Politics of Irony"
</p>
      </p>
    </>
  ),
},

{
  id: "when-will-i-win-powerball",
  title: "When Will I Win the PowerBall?",
  primaryLink: "https://learnforeverlearn.com/whenwilliwin/",
  tags: ["Lottery", "Perspective", "Education",],
  screenshots: [
    "screenshots/powerball_1.png",
    "screenshots/powerball_2.png",
  ],
  summary:
    "An educational Powerball simulator that maps your eventual win (if it ever happens) onto a human-history timeline.",
  body: (
    <>
      <p>
        This simulation mimics the drawing of your numbers every Wednesday and
        Saturday until you finally hit the Powerball jackpot, assuming you buy
        a single $2 ticket for each drawing.
      </p>
      <p>
        You can either enter specific numbers or use QuickPick, then watch a
        horizontal timeline that stretches across hundreds of thousands (or
        even millions) of years to see when your hypothetical win lands.
      </p>
      <p>
        The labels along the axis place your win in context with major events in
        human and Earth history, making the odds of winning feel
        appropriately…astronomical.
      </p>
    </>
  ),
},

  {
    id: "flame-of-life",
    title: "Flame of Life",
    primaryLink: "https://learnforeverlearn.com/candle/",
    tags: ["Life Expectancy", "Perspective"],
    screenshots: ["screenshots/flame_of_life.gif"],
    extraLinks: [
        {label: "Blog post",
                        href:"http://www.nowherenearithaca.com/2015/07/flame-of-life-d3jsthreejs-experiment.html"

        }
    ],
    summary:
      "A d3/three.js visualization using SSA life tables to show survival probabilities in a candle/flame metaphor.",
    body: (
      <>
        <p>
          This d3.js/three.js visualization uses a candle/flame metaphor to
          offer perspective on life and survival probabilities.
        </p>
        <p>
          Probabilities of living to a certain age (given you’ve reached a
          current age) are calculated from 2010 period life tables from the US
          Social Security Administration, with separate tables for males and
          females.
        </p>
        {/* <p>
          Technical notes appear in this post:{" "}
          <a
            href="http://www.nowherenearithaca.com/2015/07/flame-of-life-d3jsthreejs-experiment.html"
            target="_blank"
            rel="noreferrer"
          >
            Flame of Life: d3.js/three.js Experiment
          </a>
          .
        </p> */}
      </>
    ),
  },

  {
  id: "time-and-money",
  title: "Time & Money",
  primaryLink: "https://learnforeverlearn.com/watchtimeandmoney/",
  tags: ["Money","Budget", "Finance", "Perspective"],
  screenshots: ["screenshots/time_and_money.jpg"],
  summary:
    "Real-time money meter for salaries, hourly rates, meetings, the US budget, and more.",
  body: (
    <div className="desc-body">
      <p>
        This visualization shows money flowing in real time for different
        scenarios:
      </p>
      <ul>
        <li>Individual salaries and hourly rates.</li>
        <li>Meeting costs.</li>
        <li>US budget and government salaries.</li>
        <li>Minimum wage income, and more.</li>
      </ul>
      <p>
        It also surfaces little curiosities, such as the existence of a
        $100,000 bill.
      </p>

      {/* <div className="screenshotRow">
        <img
          src="screenshots/time_and_money.jpg"
          alt="Time & Money visualization showing bills and budget meters"
          loading="lazy"
          className="screenshotImg"
        />
      </div> */}
    </div>
  ),
},

  {
  id: "partial-exponential-sums",
  title: "Partial Sums of Exponential Sums – Interesting Journeys",
  primaryLink: "https://learnforeverlearn.com/expsums/",
  tags: ["Math", "Simulation"],
  screenshots: [
      "screenshots/expsums_1.jpg",
      "screenshots/expsums_2.jpg",
    ],
  summary:
    "Interactive playground for viewing partial sums of exponential sums, letting you sculpt complex polynomials and watch the resulting paths wander, spiral, and self-intersect.",
  body: (
    <>
      <p>
        This visualization explores the partial sums of exponential sums
        of the form{" "}
        <code>
          f(n) = Σ exp(2πi · p(n))
        </code>{" "}
        where <code>p(n)</code> is a polynomial with coefficients you can
        adjust directly.
      </p>
      <p>
        Each panel shows a different polynomial and its partial sums. You can
        tweak degrees and coefficients, load presets, randomize parameters, and
        animate the drawings as more terms are added. Depending on the choices,
        the paths can form spirals, rosettes, wandering “random walks,” or
        intricate symmetric shapes.
      </p>
    </>
  ),
},

  {
  id: "gauss-snow",
  title: "Carl Friedrich Gauss Watching Snowfall of Partial Sums of Gauss Sums",
  primaryLink: "https://learnforeverlearn.com/gauss_snow/",
  tags: ["Math", "Simulation"],
  screenshots: ["screenshots/gauss_snow.png"],
  summary:
    "A generative snow scene where each flake is a closed partial-sum path from a Gauss-sum-style exponential sum, drifting around a portrait of Gauss.",
  body: (
    <>
      <p>
        This visualization turns selected closed partial sums of Gauss sums into
        snowflakes. Each flake traces a complete run, pauses briefly when the
        path closes, and then joins a gradual snowfall around Carl Friedrich
        Gauss.
      </p>
      <p>
        The shapes come from small changes in polynomial parameters, where
        linear and quadratic terms often produce especially symmetric paths.
        The result is part math toy, part animated portrait, and part visual
        catalog of surprisingly delicate exponential-sum behavior.
      </p>
    </>
  ),
},

{
  id: "singers-formant",
  title: "Exploring the Singer’s Formant",
  primaryLink: "https://learnforeverlearn.com/formants/",
  tags: ["Voice", "Perception"],
  screenshots: ["screenshots/formants.jpg"],
  summary:
    "A sandbox for exploring the singer’s formant region with spectrograms, ‘golden’ formant overlays, and short audio samples from opera, yodeling, whistle register, and more.",
  body: (
    <>
      <p>
        This visualization lets you explore the{" "}
        <b>singer’s formant</b>—the cluster of resonances that helps trained
        voices project over an orchestra. The left panel shows a frequency
        spectrum you can scrub over to hear different regions at the same
        loudness, while a highlighted band marks the singer’s sensitive region.
      </p>
      <p>
        The right panel is a scrolling spectrogram that accumulates short
        samples from many sources: classical singers, whistle register, yodeling,
        and even baby cries. You can toggle samples on and off, compare how
        their energy lines up with the singer’s formant band, and get a feel for
        why certain voices “cut through” in a hall.
      </p>
    </>
  ),
},

{
  id: "rehearsal-helper",
  title: "Rehearsal Helper",
  primaryLink: "https://learnforeverlearn.com/rehearsalhelper/",
  tags: ["Acting", ],
      screenshots: ["rehearsal_1", "rehearsal_2", "rehearsal_3"].map(s => "screenshots/" + s + ".png"),

  summary:
    "A browser-based rehearsal buddy that plays other characters’ lines so actors can run scenes, experiment with timing, and drill cues without needing a live partner.",
body: (
    <>
      <p>
        Rehearsal Helper is a little web app for actors to rehearse scenes
        without needing a human reader. It speaks each character’s lines using
        text-to-speech, lets you loop sections, and gives you control over
        pacing and focus.
      </p>

      <p>You can either:</p>
      <ul>
        <li>
          Load a JSON-format script exported from WriterDuet (which itself can
          import Final Draft files), or
        </li>
        <li>
          Paste the text of a monologue to auto-generate a script (still in
          progress).
        </li>
      </ul>

      <p>Key features:</p>
      <ul>
        <li>
          <b>Scene / character loading:</b> pick any scene from a loaded file,
          or jump directly to a scene where a particular character is the first
          speaking role so you can focus on them.
        </li>
        <li>
          <b>Two-column layout:</b> Action on the left, characters on the
          right, with independent settings for each character.
        </li>
        <li>
          <b>Selectable voices & speaking rate:</b> each character can use a
          different text-to-speech voice and speed (whatever your device
          supports).
        </li>
        <li>
          <b>Mute / hide lines:</b> temporarily hide or mute a character so you
          can run your own lines in the gaps.
        </li>
        <li>
          <b>Loop specific sections:</b> click the checkbox or line text to
          define a loop; great for drilling tricky exchanges.
        </li>
        <li>
          <b>Timing control:</b> adjust the delay between characters, plus extra
          gap between “thoughts” (sentences/phrases) so you have time to react.
        </li>
        <li>
          <b>Block “pieces” visualization:</b> shows the internal chunks of each
          line so you can see where breaths/thoughts fall while you rehearse.
        </li>
        <li>
          <b>Printable view:</b> print the script in the same layout you see on
          screen (best when there aren’t too many characters in the scene).
        </li>
      </ul>
    </>
  ),
},

{
  id: "pickleodds",
  title: "PickleOdds: Simulating Pickleball Game Outcomes",
  primaryLink: "https://learnforeverlearn.com/pickleodds/",
  tags: ["Pickleball", "Statistics", "Simulation",],
  // assuming you're using the optional screenshots field
  screenshots: ["screenshots/pickleodds.png"],
  summary:
    "A rally-by-rally Monte Carlo simulator for pickleball that turns serving/receiving win rates into full game and scoreline distributions.",
  body: (
    <>
      <p>
        PickleOdds treats each rally in a pickleball game like a biased coin
        flip, where the bias comes from each team&apos;s historical rally win
        rate when serving and when receiving. Those rally rates are converted
        into head-to-head win probabilities using a Log5-style formula, then
        used to simulate thousands of games.
      </p>
      <p>
        You can adjust Team A and Team B&apos;s rally win percentages (serving
        and receiving independently), choose game type and number of simulated
        games, and then see:
      </p>
      <ul>
        <li>
          Overall match win probabilities for each team under different match
          formats (single game, best-of-3, best-of-5).
        </li>
        <li>
          Histograms of scorelines when each team wins, highlighting blowouts,
          nail-biters, and “pickle” games.
        </li>
        <li>
          Cumulative distributions showing how likely each team is to win by a
          given score or better.
        </li>
      </ul>
      <p>
        It&apos;s meant as a light-weight way to build intuition about how small
        differences in rally win rate translate into game outcomes and final
        scores, without getting lost in heavy probability formulas.
      </p>
    </>
  ),
},

{
  id: "split-depth-gif",
  title: "Split Depth Experiment",
  primaryLink: "https://learnforeverlearn.com/splitdepth/",
  tags: ["Perception"],
  summary:
    "A playful Three.js experiment that creates a 3-D ‘split-depth’ illusion using floating chrome spheres and adjustable frame bars.",
  body: (
    <>
      This visualization bends a 2D scene into a 3D experience by placing reflective spheres at various depths and 
      letting the viewer control framing bars that trick the brain into seeing a stereoscopic effect.  
      Built with <b>Three.js</b>, real-world HDRI environments (Paul Debevec), and a few slider-driven rendering quirks 
      to break the boundary between flat imagery and spatial perception.
      <br /><br />
      You can:
      <ul>
        <li>Adjust “bar depth” to control where the illusion locks on.</li>
        <li>Modify bar widths and colors to shape the stereoscopic frame.</li>
        <li>Reset animation or camera separately to explore the effect.</li>
        <li>Observe reflections updating according to real lighting data.</li>
      </ul>
    </>
  ),
  screenshots: [
    "screenshots/splitdepth.png"
  ]
},

{
  id: "pickleball-game-viewer",
  title: "Pickleball Game Viewer & Rally Insights",
  primaryLink: "https://learnforeverlearn.com/pickleballgameviewer/",
  tags: ["Pickleball", ],
        screenshots: ["pickleballgameviewer_1", "pickleballgameviewer_2", "pickleballgameviewer_3"].map(s => "screenshots/" + s + ".png"),

  summary:
    "Interactive rally-by-rally viewer that layers icons, stats, and clips to surface the most actionable pickleball points from a match.",
  body: (
    <>
      <p>
        This tool takes a single pickleball match and turns it into an
        interactive, rally-by-rally storyboard. Each rally is annotated with
        icons (ATP, Attack, Beast Mode, Net Cord, Grey Zone, Unforced Error,
        etc.) and basic stats so you can quickly spot the most instructive
        points.
      </p>
      <p>
        The <b>Main</b> view shows the entire match as a horizontal timeline of
        rallies, with icons, serving / winner info, and shots-per-rally stacked
        underneath. Hovering a rally reveals a summary panel and an embedded
        video clip so you can immediately watch that sequence in context.
      </p>
      <p>
        Tabs along the top filter the match into focused slices:
      </p>
      <ul>
        <li>
          <b>Interesting</b> – rallies with something strategically or
          tactically noteworthy.
        </li>
        <li>
          <b>Beast Mode</b> – full-attack points where someone really unloads.
        </li>
        <li>
          <b>Unforced Errors</b> – rallies ending in clean mistakes, useful for
          identifying patterns to tighten up.
        </li>
        <li>
          <b>Net Cord</b> and <b>Grey Zone</b> – quirky or high-pressure
          transition-zone exchanges that often decide points.
        </li>
      </ul>
      <p>
        A legend explains each icon so the shorthand is readable at a glance.
        The overall goal is to <b>surface and prioritize actionable insights</b>{" "}
        from a match instead of just presenting a long, undifferentiated video.
        It&apos;s designed as a coach / self-review tool to jump straight to the
        rallies that matter most for improvement.
      </p>
    </>
  ),
},

{
  id: "pickleball-trajectory-explorer",
  title: "Pickleball Trajectory Explorer",
  primaryLink: "https://learnforeverlearn.com/pickleball/",
  tags: ["Pickleball", ],
  screenshots: [
    "screenshots/pickleball_trajectory.png", // or whatever filename you’re using
  ],
  summary:
    "A physics-based sandbox for exploring pickleball trajectories with adjustable speed, spin, height, and drag.",
  body: (
    <>
      <p>
        This beta tool treats each shot as a simple projectile with drag and
        spin, letting you visualize how different contact points and ball
        parameters affect the arc over the net.
      </p>
      <p>
        You can choose among preset “starting places” or tweak everything
        directly to see how small changes influence the outcome.
      </p>
      <ul>
        <li>
          Adjust opponent ball speed, launch angle, contact height, and distance
          from the net.
        </li>
        <li>
          Set your own reach, distance from the kitchen line, and paddle
          position to see where you’d meet the ball.
        </li>
        <li>
          Experiment with ball RPM and drag to compare topspin vs. backspin
          arcs.
        </li>
        <li>
          Toggle paddle information and animation to focus on just the
          trajectory or the full interaction.
        </li>
      </ul>
      <p>
        It’s mainly a thinking/intuition tool for how shot shape, contact point,
        and spin interact in pickleball—especially around the kitchen line.
      </p>
    </>
  ),
},

{
  id: "reaction-time-trainer",
  title: "Reaction Time Trainer",
  primaryLink: "https://learnforeverlearn.com/reaction_trainer/",
  tags: ["Psychology", ],
  summary:
    "A tiny browser-based reaction-time trainer that lets you measure and track how quickly you respond to a visual cue.",
  screenshots: ["screenshots/reaction_trainer.png"],
  body: (
    <>
      <p>
        This tool shows a simple red circle on the screen and measures how long
        it takes you to hit the space bar after it appears. Each attempt is
        logged in a small results table with your reaction time and timestamp.
      </p>
      <p>
        It&apos;s intentionally minimal: you can repeatedly test your reaction
        time, see how it varies over multiple trials, and experiment with
        techniques (like the NIH study it links to about breath-holding) to see
        whether they make any noticeable difference for you.
      </p>
    </>
  ),
},
{
  id: "actress-compare",
  title: "Side-by-Side Audition Comparison",
  // TODO: update this to the actual URL if it’s different
  primaryLink: "https://learnforeverlearn.com/actress_compare/",

  tags: ["Acting", ],
  screenshots: ["screenshots/actress_compare.png"],
  extraLinks: [
    {label: "Youtube", href: "https://www.youtube.com/watch?v=bsl-XFvtW_c&t=15s"}

],
  summary:
    "A small tool for comparing two audition takes side by side—syncing starts, toggling audio, and quickly A/B-ing moments in the performance.",
  body: (
    <>
      <p>
        This tool was built to compare different acting takes (or different
        performers) in a very concrete, visual way. You can load two videos,
        line them up, and scrub them in sync.
      </p>
      <p>While a bit cacophonous, you can really see the differences in performance.  This got more than a million views on youtube.</p>
      <p>
        The interface keeps the timelines aligned so you can:
      </p>
      <ul>
        <li>Start both videos together and pause/resume in sync.</li>
        <li>Toggle audio between left/right to focus on one performance.</li>
        <li>Jump to key beats to see how choices differ moment by moment.</li>
      </ul>
      <p>
        It came out of wanting something more precise than just flipping
        between browser tabs while preparing or reviewing audition material.
      </p>
    </>
  ),
},


{
  id: "pbskills-universe",
  title: "Partial Universe of Pickleball Skills",
  primaryLink: "https://learnforeverlearn.com/pbskills/",
  tags: ["Pickleball", "Education", ],
  summary:
    "A map of pickleball skills —levels 3.5–6.0, and 6.0-invisible skills, aggression, context shots, and more orbiting a central pickleball.",
  screenshots: [
    "screenshots/pbskills_main.png",
    "screenshots/pbskills_drills.png",
  ],
  body: (
    <>
      <p>
        This visualization lays out a large set of pickleball skills as a
        galaxy of connected nodes grouped by level (3.5–6.0 and invisible
        skills) and themes such as aggression, context shots, transition zone,
        communication, and more.
      </p>
      <p>
        You can use level filters across the
        top, and browse drill ideas that connect directly to the skills on the
        map.
      </p>
    </>
  ),
},

  {
    id: "tn-legislation-explorer",
    title: "Tennessee Legislation Explorer",
    primaryLink: "https://learnforeverlearn.com/legislature/",
    tags: ["Legislation"],
    screenshots: ["screenshots/tn_legislation.png"],
    summary:
      "An evolving project using Legiscan data to explore bills in the Tennessee General Assembly.",
    body: (
      <>
        <p>
          This evolving project experiments with ways to explore bill activity
          in the Tennessee General Assembly.
        </p>
        <p>
          It relies on datasets from{" "}
          <a
            href="https://legiscan.com/TN/datasets"
            target="_blank"
            rel="noreferrer"
          >
            Legiscan
          </a>
          , which provides weekly snapshots of session data.
        </p>
      </>
    ),
  },

  {
    id: "text-analysis-bigram",
    title: "Text Analysis Bigram Explorer",
    primaryLink: "https://learnforeverlearn.com/loglikelihood/",
    tags: [ "Bigrams",],
    screenshots: ["screenshots/bigrams.png"],
    summary:
      "Surfacing ‘interesting’ bigrams by log-likelihood ratio, with built-in corpora and support for custom uploads.",
    body: (
      <>
        <p>
          This app lets you explore “interesting” bigrams ranked by
          log-likelihood ratio, a simple statistic described in detail in Ted
          Dunning’s work.
        </p>
        <p>
          You can choose from built-in texts (Alice in Wonderland, all works of
          Poe, etc.) or upload your own text file and see which bigrams stand
          out.
        </p>
      </>
    ),
  },


  {
    id: "us-births-deaths",
    title: "US Births and Deaths, Simulated in Real-Time",
    primaryLink: "https://learnforeverlearn.com/usbirthsdeaths/",
    tags: ["Population", "Perspective", "Simulation",],
    screenshots: ["screenshots/usbirths.png"],
    summary:
      "Similar to the global simulation, but focused on US births/deaths with county and city-level population data.",
    body: (
      <>
        <p>
          A statistical simulation of births and deaths in the United States,
          using the national average birth and death rates.
        </p>
        <p>
          Population information for all US counties and thousands of cities is
          used to simulate where events are likely to occur. This is another
          collaboration with{" "}
          <a href="http://snebold.com/" target="_blank" rel="noreferrer">
            Bill Snebold
          </a>
          .
        </p>
      </>
    ),
  },

  {
    id: "us-tweet-map",
    title: "US Tweet Map, Searchable in Real-Time",
    // primaryLink: "https://ustweetmap-bflnni.rhcloud.com/",
    tags: ["Twitter"],
    extraLinks: [{
        label: "Blog post", href: "https://www.nowherenearithaca.com/2014/03/a-searchable-us-tweet-map-nodejsd3oauth.html"
    }],
    screenshots: ["screenshots/worldtweet_mailchimp.png"],
    summary:
    "A US-focused variant of the real-time tweet map using the (now unavailable) Twitter API v1.1, limited to tweets in the United States.",
    body: (
      <>
        {/* <p>
          A US-focused variant of the real-time tweet map using the (now unavailable) Twitter
          API v1.1, limited to tweets in the United States.
        </p> */}
        {/* <p>
          This was the very first Node.js project in this collection. It uses
          d3.js, Node.js, mongoose, express, passport.js, and request.js, and
          was also deployed on OpenShift.
        </p> */}
        <p>
          The design echoes the US births/deaths visualization.
        </p>
      </>
    ),
  },

  {
    id: "quicksort-visualizations",
    title: "Visualizations to Help Understand Quicksort",
    primaryLink: "https://learnforeverlearn.com/exploringquicksort/",
    screenshots: ["sort_1", "sort_2", "sort_3", "sort_4"].map(s => "screenshots/" + s + ".png"),
    extraLinks: [
      {
        label: "Divide-and-Conquer",
        href: "https://learnforeverlearn.com/exploringquicksort/",
      },
      {
        label: "Basic Partitioning",
        href: "https://learnforeverlearn.com/pivot_music/",
      },
      {
        label: "Bentley/McIlroy 3-Way Partitioning",
        href: "https://learnforeverlearn.com/pivot_3way_music/",
      },
      {
        label: "Yarovslavskiy Partitioning",
        href: "https://learnforeverlearn.com/yaro_web/",
      },
    ],
    tags: ["Algorithms",  "Education"],
    summary:
      "A series of Quicksort visualizations, including dual-pivot Yarovslavskiy partitioning, with annotations and experimental sonification.",
    body: (
      <>
        <p>
          This is a family of visualizations that build intuition for Quicksort,
          culminating in the dual-pivot partitioning scheme by Vladimir
          Yarovslavskiy (adopted in Java 7).
        </p>
        <p>
          Each visualization uses annotations, and some include experimental
          audibilization:
        </p>
        <ul>
          <li>High-level divide-and-conquer behavior.</li>
          <li>Basic partitioning.</li>
          <li>Bentley/McIlroy 3-way partitioning.</li>
          <li>Yarovslavskiy dual-pivot partitioning with highlighted pseudo-code.</li>
        </ul>
      </>
    ),
  },

  {
    id: "when-were-you-conceived",
    title: "When were you conceived?",
    primaryLink: "https://learnforeverlearn.com/whenconceived/",
    tags: ["Birthdays"],
    screenshots: ["screenshots/conceived.png"],
    summary:
      "Turns birthday popularity data into a conception-date explorer, with responsive layout across window sizes.",
    body: (
      <>
        <p>
          This started as an experiment in viewing the popularity of birthdays
          and evolved into an interactive tool that shows the popularity of
          “conception days” and helps you explore conception dates for a given
          birthday.
        </p>
        {/* <p>
          The visualization is responsive across a wide range of window sizes
          and dynamically adjusts as the window is resized.
        </p> */}
        <p>
          Birthday popularity data came from a{" "}
          <a
            href="http://www.nytimes.com/2006/12/19/business/20leonhardt-table.html?_r=1"
            target="_blank"
            rel="noreferrer"
          >
            New York Times table
          </a>
          , which itself was based on 1973–1999 data collected by Amitabh
          Chandra at Harvard.
        </p>
      </>
    ),
  },

//   {
//     id: "when-will-i-win-powerball",
//     title: "When Will I Win the PowerBall?",
//     primaryLink: "https://learnforeverlearn.com/newwhenwilliwin/",
//     tags: ["Lottery", "Perspective"],
//     summary:
//       "Uses lottery odds to show when you might expect to win if you play twice a week—typically on million-year timescales.",
//     body: (
//       <>
//         <p>
//           We all “know” the chance of winning the lottery is tiny. This
//           visualization turns that tiny probability into an intuitive sense of{" "}
//           when{" "}
//           you might expect to win if you played twice a week.
//         </p>
//         <p>
//           It has been covered by{" "}
//           <a
//             href="http://www.citylab.com/work/2016/01/powerball-jackbot-odds-simulator-brad-lyon-when-will-i-win/423864/"
//             target="_blank"
//             rel="noreferrer"
//           >
//             The Atlantic’s CityLab
//           </a>{" "}
//           and even in a Hungarian banking site article.
//         </p>
//         <p>
//           Spoiler: you probably need on the order of a million years. Fran
//           Lebowitz summed it up:{" "}
//           <i>
//             “I&apos;ve done the calculation and your chances of winning the
//             lottery are identical whether you play or not.”
//           </i>
//         </p>
//       </>
//     ),
//   },

  {
    id: "world-births-deaths",
    title: "World Births and Deaths, Simulated in Real-Time",
    primaryLink: "http://worldbirthsanddeaths.com/",
    extraLinks: [
      // {
      //   label: "Chrome App",
      //   href: "https://chrome.google.com/webstore/detail/world-birthsdeaths-in-rea/noghphokfbhedlkhnoojmjfdbofidgbi",
      // },
    ],
    screenshots: ["screenshots/worldbirths.png"],
    tags: ["Population", "Perspective", "Simulation",],
    summary:
      "A statistical simulation of global births and deaths, using country-specific birth/death rates and religion affiliationg tied to ~20,000 cities worldwide.",
    body: (
      <>
        <p>
          This is a statistical simulation of births and deaths across the
          globe, using country-specific birth and death rates and the
          populations of about 20,000 cities.
        </p>
        <p>
          It is one thing to read that there are ~4 births per second and ~2
          deaths per second; it’s another to see it play out visually. The
          visualization has appeared in <i>The Atlantic</i> and{" "}
          <i>The Atlantic Cities</i>, and was named by PCWorld in July 2014 as
          one of “10 sites with stunning visual data that will change your world
          view.” Created in collaboration with{" "}
          <a href="http://snebold.com/" target="_blank" rel="noreferrer">
            Bill Snebold
          </a>
          .
        </p>
        {/* <p>
          There is also a Chrome app version available in the Chrome Web Store.
        </p> */}
      </>
    ),
  },

  {
    id: "world-tweet-map",
    title: "World Tweet Map, Searchable in Real-Time",
    // primaryLink: "https://worldtweetmap-bflnni.rhcloud.com/",
    tags: ["Twitter"],
    extraLinks: [
{label: "Blog post", href: "https://www.nowherenearithaca.com/2014/03/a-searchable-real-time-world-tweet-map.html"}
    ],
    screenshots: ["screenshots/worldtweets_mailchimp.png"],
    summary:
      "Real-time searchable world tweet map.",
    body: (
      <>
        <p>
          This project uses the (now unavailable) Twitter API (v1.1) to allow real-time searching
          of public tweets across the globe.
        </p>
        {/* <p>
          It was one of the first Node.js projects for this portfolio. The
          stack includes d3.js, Node.js, mongoose, express, passport.js, and
          request.js, and was deployed on RedHat’s OpenShift (free tier).
        </p> */}
        <p>
          The overall design echoes the earlier world births/deaths
          visualization.
        </p>
      </>
    ),
  },
];

// PROJECTS_OLD remains as-is below…
